import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import * as HudlFeed from 'hudl-feed';
import homeReducer from '../reducers';
import legacyTimelineReducer from '../reducers/legacy';

export function buildStore(initialState, reducers) {
  // Add support for Redux devtools
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  return createStore(reducers, initialState, composeEnhancers(applyMiddleware(thunkMiddleware)));
}

export function configureHomeStore(initialState) {
  const { defaultState: defaultFeedState } = HudlFeed.store;
  const initialStoreState = Object.assign({}, defaultFeedState, initialState);
  return buildStore(initialStoreState, homeReducer);
}

// Used by profiles until they are updated to use the NPM package for the timeline
export function configureTimelineStore(initialState) {
  return buildStore(initialState, legacyTimelineReducer);
}

export function configureExploreStore(initialState) {
  return buildStore(initialState, homeReducer);
}
